import API_ENDPOINTS from "../components/config/apiConfig";
import { getFirebaseToken } from "../utils/auth";

async function getAuthToken() {
  return await getFirebaseToken();
}

export async function addServiceAvailabilityException(serviceType, serviceId, exceptionData) {
  try {
    const token = await getAuthToken();
    const url = API_ENDPOINTS.ADD_SERVICE_AVAILABILITY_EXCEPTION(serviceType, serviceId);

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(exceptionData)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Failed to add availability exception');
    }

    return await response.json();
  } catch (error) {
    console.error('Error adding service availability exception:', error);
    throw error;
  }
}

export async function getAvailabilityExceptions(serviceType, serviceId) {
  try {
    const token = await getAuthToken();
    const url = API_ENDPOINTS.GET_AVAILABILITY_EXCEPTIONS(serviceType, serviceId);

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Failed to fetch availability exceptions');
    }

    return await response.json();
  } catch (error) {
    console.error('Error getting availability exceptions:', error);
    throw error;
  }
}

export async function deleteAvailabilityException(exceptionId) {
  try {
    const token = await getAuthToken();
    const url = API_ENDPOINTS.DELETE_AVAILABILITY_EXCEPTION(exceptionId);

    const response = await fetch(url, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Failed to delete availability exception');
    }

    return await response.json();
  } catch (error) {
    console.error('Error deleting availability exception:', error);
    throw error;
  }
}